import { PositionQualificationChat } from "./position_qualification_chat";

export class PositionQualificationChats extends Array<PositionQualificationChat> {
  constructor(positionQualificationChats?: PositionQualificationChat[]) {
    super();
    if (positionQualificationChats instanceof Array) {
      positionQualificationChats.forEach((positionQualificationChat) =>
        this.push(positionQualificationChat),
      );
    }
  }
}
